import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LightboxComponent } from "./lightbox.component";
import { MatIconModule } from "@angular/material/icon";
import { SharedPipesModule } from "../../pipes/shared-pipes.module";

@NgModule({
  declarations: [LightboxComponent],
  imports: [CommonModule, MatIconModule, SharedPipesModule],
  exports: [LightboxComponent],
})
export class LightboxModule {}
